import {
  useShouldRender,
  Props as ShouldRenderProps,
} from './hooks/useShouldRender';

/**
 * This config mostly applies to admins, but not exclusively. Prevents other
 * TopBar banners from rendering.
 */
const UnlimitedAccountBanner = () => null;

UnlimitedAccountBanner.shouldRender = function shouldRender(
  props: ShouldRenderProps = {}
) {
  return useShouldRender.call(this, props);
};

export { UnlimitedAccountBanner };
